import { render } from "./Changelanguage.vue?vue&type=template&id=53736b26&scoped=true"
import script from "./Changelanguage.vue?vue&type=script&lang=js"
export * from "./Changelanguage.vue?vue&type=script&lang=js"

import "./Changelanguage.vue?vue&type=style&index=0&id=53736b26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53736b26"]])

export default __exports__